import isArray from 'utils/isArray';

const targetImageObject = image => {
  // instead of 'localFile' field we have to have 'gatsbyImageData' field in the root of the object
  // current image object:
  /*
		{
			id: '123',
			title: 'My Image',
			localfile: {
				childImageSharp: {
					gatsbyImageData: {
						...
					}
				}
			}
		}
	*/

  // target image object:
  /*
		{
			id: '123',
			title: 'My Image',
			gatsbyImageData: {
				...
			}
		}
	*/
  const imageWithoutLocalFileKey = {
    ...image,
    gatsbyImageData: image.localFile.childImageSharp.gatsbyImageData,
  };
  delete imageWithoutLocalFileKey.localFile;
  return imageWithoutLocalFileKey;
};

function isGif(image) {
  const isLocalFileExtensionGif = image?.localFile?.extension === 'gif';
  const isExtensionInFileUrlGif = image?.file?.url?.endsWith('gif');
  return isLocalFileExtensionGif || isExtensionInFileUrlGif;
}

function isValidLocalFile(image) {
  return !!image.localFile?.childImageSharp?.gatsbyImageData;
}

function getTargetImageObject(image) {
  if (isGif(image)) return image;
  if (!isValidLocalFile(image)) return;
  return targetImageObject(image);
}

function getGatsbyImageObjectArray(images) {
  return images.map(image => getTargetImageObject(image)).filter(Boolean);
}

function getGatsbyImageObject(imagesArrayOrImageObject) {
  if (!imagesArrayOrImageObject) return;

  if (isArray(imagesArrayOrImageObject)) return getGatsbyImageObjectArray(imagesArrayOrImageObject);

  return getTargetImageObject(imagesArrayOrImageObject);
}

export default getGatsbyImageObject;
